
import { Component, Vue, Watch, Prop, Emit } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action, State } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import SkeletonLoader from "../SkeletonLoader.vue"
import vSelect from "vue-select"
import dashboardApi from "@/services/api.dashboard"

import api from "@/services/api"
import { DashboardSummary } from "@/types/dashboard"

const caseStore = namespace("cases")
const setup = namespace("setup")

@Component({
	components: {
		"scrollbar": VuePerfectScrollbar,
		"skeleton": SkeletonLoader,
		"v-select": vSelect
	}
})
export default class GoTo extends Vue {
@Prop()
value: any;

@Prop()
edit!: boolean

dashboards: any[] = [];
activeGoTo: any = null;

public async mounted () {
	this.onEditChanged()
}

@Watch("edit")
private async onEditChanged () {
	this.dashboards = await dashboardApi.dashboardGetList()
	if (this.value) {
		this.activeGoTo = this.value
	}
}

@Emit("input")
private selectDashboard (value: any) {
	if (value) {
		value = {
			id: value.id,
			title: value.title
		}
		this.activeGoTo = value
		return { ...value }
	} else {
		return null
	}
}

private GoTo () {
	this.$emit("dashboardTrigger", { ...this.value }, "goTo")
}
}
